import * as React from "react";
import { CircleCheck, Info, OctagonX, TriangleAlert } from "lucide-react";

import { Alert, AlertDescription } from "@/components/ui/alert";
import { cn } from "@/lib/utils";

export type SimulatorAlertTone = "info" | "warning" | "error" | "success";

export const SIMULATOR_ALERT_CLASS =
  "font-[family-name:var(--font-primary)]";

export function SimulatorAlertIcon({
  tone,
}: {
  tone: SimulatorAlertTone;
}): React.ReactElement {
  switch (tone) {
    case "success":
      return <CircleCheck aria-hidden />;
    case "warning":
      return <TriangleAlert aria-hidden />;
    case "error":
      return <OctagonX aria-hidden />;
    default:
      return <Info aria-hidden />;
  }
}

export type SimulatorAlertProps = Omit<React.ComponentProps<typeof Alert>, "variant"> & {
  tone: SimulatorAlertTone;
  children: React.ReactNode;
};

export function SimulatorAlert({
  tone,
  children,
  className,
  ...props
}: SimulatorAlertProps): React.ReactElement {
  return (
    <Alert
      variant={tone}
      className={cn(SIMULATOR_ALERT_CLASS, className)}
      data-simulator-alert=""
      data-simulator-alert-tone={tone}
      {...props}
    >
      <SimulatorAlertIcon tone={tone} />
      <AlertDescription>{children}</AlertDescription>
    </Alert>
  );
}
